import type {
  KpiChiffreAffaireGlobalViewModel,
  KpiRepartitionsChiffreAffaireCombinedListViewModel
} from '@/lib/types'
import baseRepository from '@/repository/BaseRepository.ts'
import {getStoredEndDate, getStoredStartDate} from '@/lib/localStorage.ts'

export default {
  async getInfoCardData(): Promise<KpiChiffreAffaireGlobalViewModel> {
    const url = await baseRepository.buildUrl(`api/kpi-chiffre-affaires/global?start_date=${getStoredStartDate()}&end_date=${getStoredEndDate()}`)
    return baseRepository.fetchData<KpiChiffreAffaireGlobalViewModel>(url)
  },
  async getRepartitionData(): Promise<KpiRepartitionsChiffreAffaireCombinedListViewModel[]> {
    const url = await baseRepository.buildUrl(
      `api/kpi-chiffre-affaires/repartitions-chiffre-affaire?start_date=${getStoredStartDate()}&end_date=${getStoredEndDate()}`,
    )
    return baseRepository.fetchData<KpiRepartitionsChiffreAffaireCombinedListViewModel[]>(url)
  },
}
